import { AxiosInstance } from 'axios';
import { BaseRequest } from '@trukt/types/BaseRequest';
import { Activity } from '@trukt/types/Activity';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';

export type ActivitySearchRequest = BaseRequest<
  Pick<PaginatedQueryParams, 'pg' | 'rc'>,
  void,
  { jobGuid: string; orderGuid: string }
>;
export type ActivitySearchResponse = PaginatedResults<Activity>;

export class ActivityService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search({ routeParams, queryParams }: ActivitySearchRequest) {
    return this.instance.get<ActivitySearchResponse>(
      `activitylogs/${routeParams.orderGuid}/${routeParams.jobGuid}`,
      {
        params: queryParams,
      },
    );
  }
}
